import { Typography } from 'antd';
const { Text } = Typography;

const ReadOnlyAddressCard: React.FC<{ title: string; name?: string; street?: string; city?: string; state?: string; zip?: string; country?: string; }> =
({ title, name, street, city, state, zip, country }) => {
  const line = (v?: string) => (String(v ?? '').trim() ? v : '—');

  return (
    <div className="rounded-lg border border-slate-200 bg-slate-50 px-3 py-2">
      <Text strong>{title}</Text>

      <div className="mt-2 text-sm space-y-1">
        <div className="text-slate-900 font-medium">{line(name)}</div>
        <div className="text-slate-700">{line(street)}</div>
        <div className="text-slate-700">
          {line(city)}{city || state ? ', ' : ''}{line(state)} {line(zip)}
        </div>
        <div className="text-slate-700">{line(country)}</div>
      </div>
    </div>
  );
};

export default ReadOnlyAddressCard